import { graphql } from 'babel-plugin-relay/macro';
import {
  WordOrderExerciseContentInput,
  CreateWordOrderExerciseMutation,
} from './__generated__/CreateWordOrderExerciseMutation.graphql';
import { commitMutationPromise } from '../lib/graphqlUtils';
import {
  addExerciseToStore,
  optimisticCreateExerciseUpdater,
} from './helpers/exerciseMutationHelpers';
const mutation = graphql`
  mutation CreateWordOrderExerciseMutation(
    $input: CreateWordOrderExerciseInput!
  ) {
    createWordOrderExercise(input: $input) {
      exercise {
        id
        content {
          correctAnswers
          scrambledParts
        }
        worksheet {
          id
        }
      }
    }
  }
`;

const commit = (
  environment: any,
  worksheetId: string,
  content: WordOrderExerciseContentInput,
  position: number,
) =>
  commitMutationPromise<CreateWordOrderExerciseMutation>(environment, {
    mutation,
    variables: {
      input: {
        worksheetId,
        content,
        position,
      },
    },
    optimisticUpdater: optimisticCreateExerciseUpdater(
      'WordOrderExercise',
      worksheetId,
      content,
      position,
    ),
    updater: store => {
      const payload = store.getRootField('createWordOrderExercise');
      if (payload) {
        const newExercise = payload.getLinkedRecord('exercise');
        addExerciseToStore(store, newExercise, worksheetId, position);
      }
    },
  });

export default {
  commit,
};
